import type { SessionConfig } from '@/api/session-state/types';
import { create } from 'zustand';

export const defaultSessionConfig: SessionConfig = {
  carrierPinOptions: {
    isAllowed: false,
    encryptionRequired: false,
  },
  searchForPlans: true,
  requirePlans: false,
  threatMetrixEnabled: false,
};

export const useSessionConfig = create<SessionConfig>(
  () => defaultSessionConfig,
);
